var _rect, _g, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChannelPartner = function SvgChannelPartner(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 203,
    viewBox: "0 0 255 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 203,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.908 56V156.804C246.908 160.118 244.221 162.804 240.908 162.804H14C10.6863 162.804 8 160.118 8 156.804V147.041C8 145.409 9.32325 144.085 10.9556 144.085C12.5879 144.085 13.9111 142.762 13.9111 141.13V124.981C13.9111 122.535 15.3961 120.334 17.6643 119.418L37.4213 111.439C38.7775 110.891 39.8869 109.867 40.5411 108.559L52.1528 85.3353C53.1691 83.3026 55.2467 82.0185 57.5194 82.0185H76.3816C79.6953 82.0185 82.3816 79.3323 82.3816 76.0185V56C82.3816 52.6863 85.0679 50 88.3816 50H240.908C244.221 50 246.908 52.6863 246.908 56Z",
    fill: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.404,
    cy: 162.804,
    rx: 16.2556,
    ry: 20.1963,
    fill: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.367,
    cy: 162.804,
    rx: 16.2556,
    ry: 20.1963,
    fill: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1076,
    cy: 162.804,
    rx: 16.2556,
    ry: 20.1963,
    fill: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.085,
    cy: 162.804,
    rx: 16.2556,
    ry: 20.1963,
    fill: "#E1F5FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 148.578L160.459 148.578L160.459 180.629C160.459 183.232 158.348 185.342 155.745 185.342L98.7134 185.342C96.1103 185.342 94 183.232 94 180.629L94 148.578Z",
    fill: "url(#paint0_linear_1035_1100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.312 148.578L160.459 148.578L160.459 180.629C160.459 183.232 158.348 185.342 155.745 185.342L142.312 185.342L142.312 148.578Z",
    fill: "url(#paint1_linear_1035_1100)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.904,
    y: 152.349,
    width: 13.1975,
    height: 3.7707,
    rx: 0.942675,
    fill: "#8BCAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 145,
    width: 49,
    height: 4,
    fill: "#B7DDFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 145,
    width: 19,
    height: 4,
    fill: "#87C8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108.548L165.459 108.548L165.459 140.287C165.459 142.89 163.348 145 160.745 145L103.713 145C101.11 145 99 142.89 99 140.287L99 108.548Z",
    fill: "url(#paint2_linear_1035_1100)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.312 108.548L165.459 108.548L165.459 140.287C165.459 142.89 163.348 145 160.745 145L147.312 145L147.312 108.548Z",
    fill: "url(#paint3_linear_1035_1100)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 149.904,
    y: 112.286,
    width: 13.1975,
    height: 3.73869,
    rx: 0.942675,
    fill: "#8BCAFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 105,
    width: 49,
    height: 3.96604,
    fill: "#B7DDFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 105,
    width: 19,
    height: 3.96604,
    fill: "#87C8FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.06,
    x: 221,
    y: 144,
    width: 30,
    height: 19,
    rx: 4,
    fill: "#E1F5FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_1100",
    x1: 126.994,
    y1: 153.527,
    x2: 127.575,
    y2: 185.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_1100",
    x1: 151.503,
    y1: 148.578,
    x2: 143.962,
    y2: 186.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1035_1100",
    x1: 131.994,
    y1: 113.455,
    x2: 132.565,
    y2: 144.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1035_1100",
    x1: 156.503,
    y1: 108.548,
    x2: 149.084,
    y2: 146.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChannelPartner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "channel_partner.4d5fc131afc5104c728023fdfec793e0.svg";